import { computed, type ComputedRef } from 'vue'
import { useBreadcrumb_experimental } from '@/vue/components/navigation/BreadcrumbNav/use-breadcrumbs'

export function useAssetOnlyAccess(): ComputedRef<boolean> {
    const { company, portfolio } = useBreadcrumb_experimental()
    return computed(() => {
        // Check portfolio-level access first (more specific)
        if (portfolio.value?.asset_only_access !== undefined) {
            return portfolio.value.asset_only_access
        }
        // Fall back to company-level access
        return company.value?.asset_only_access ?? false
    })
}
